import { render, staticRenderFns } from "./ConferenceList.vue?vue&type=template&id=a8430c12&"
import script from "./ConferenceList.vue?vue&type=script&lang=ts&"
export * from "./ConferenceList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports